import styled from 'styled-components';
import { media } from 'styleUtils';

const DefaultContainer = styled.div`
  width: 90%;
  max-width: 345px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: 60px 25px;

  ${media.tablet`
    max-width: 615px;
  `}
`;

export default DefaultContainer;
